/* ==========================================================================
   Floricultura Edelweiss — página de finalizar pedido

   31/08/2026, 2ª versão. A 1ª montava uma mensagem e abria o WhatsApp. O Erik
   mandou que **a finalização acontecesse no próprio site**, então esta tela
   passou a ser a antessala do CHECKOUT DA SHOPIFY, e não mais de uma conversa.

   O QUE MUDOU DE ARQUITETURA. O carrinho continua vivendo em localStorage —
   é ele que desenha a gaveta em todas as páginas e que sobrevive entre
   visitas. Mas ele deixou de ser o fim da linha: no momento do pagamento, o
   conteúdo é COPIADO para o carrinho nativo da Shopify (`/cart/add.js`) e o
   navegador vai para `/checkout`. Endereço, frete e pagamento passam a ser
   responsabilidade da Shopify, que é quem cobra.

   POR ISSO ESTA PÁGINA ENCOLHEU. Saíram os blocos de endereço, de "quem está
   pedindo" e de forma de pagamento: o checkout da Shopify pede os três, e
   pedir duas vezes é o atrito mais caro que uma loja pode inventar. Ficou o
   que a Shopify NÃO pergunta e a floricultura precisa saber — quem recebe,
   em que dia, em que janela, e o que vai escrito no bilhete.

   Esses quatro viajam como ATRIBUTOS DO CARRINHO (`/cart/update.js`), e não
   como texto solto: atributo aparece no pedido dentro do admin, junto da
   etiqueta de envio. Nota no rodapé de e-mail ninguém lê na hora de montar.

   DEPENDE DO app.js e a ordem dos <script> importa: `window.EDELWEISS` é
   montado lá, e é dele que vêm PRODUTOS, VARIANTES e o patamar de frete.
   ========================================================================== */
(function () {
  'use strict';

  var E = window.EDELWEISS;
  if (!E) return;

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var form = $('[data-checkout]');
  if (!form) return;

  var money = E.money;
  var achar = E.achar;

  /* `window.Shopify` só existe na loja publicada — quem o define é o
     `content_for_header` do layout. No protótipo aberto do disco ou pelo
     servidor local ele não existe, e não existe `/cart/add.js` nenhum para
     chamar. A página continua idêntica; o que muda é a mensagem do botão. */
  var NA_LOJA = typeof window.Shopify === 'object' && !!window.Shopify.shop;

  /* =======================================================================
     O RESUMO
     ======================================================================= */

  function pintarResumo() {
    var s = E.ler();
    var alvo = $('[data-checkout-linhas]');
    var vazio = $('[data-checkout-vazio]');

    if (form)  form.classList.toggle('is-hidden', s.length === 0);
    if (vazio) vazio.classList.toggle('is-hidden', s.length !== 0);

    if (!alvo) return;
    alvo.innerHTML = s.map(function (l) {
      var p = achar(l.id);
      if (!p) return '';
      var props = '';
      if (l.props) {
        props = Object.keys(l.props).filter(function (k) { return l.props[k]; })
          .map(function (k) { return '<p class="linha-item__prop">' + k + ': ' + l.props[k] + '</p>'; })
          .join('');
      }
      return '<div class="ck-linha">' +
        '<img src="' + p.img + '" alt="">' +
        '<div><p class="linha-item__n">' + p.nome + '</p>' + props +
          '<p class="ck-linha__q">' + l.qtd + ' × ' + money(p.preco) + '</p></div>' +
        '<span class="linha-item__p">' + money(p.preco * l.qtd) + '</span>' +
      '</div>';
    }).join('');

    if (window.lucide && typeof window.lucide.createIcons === 'function') {
      window.lucide.createIcons();
    }
  }

  /* =======================================================================
     A DATA

     `min` é hoje, no fuso do NAVEGADOR. `new Date().toISOString()` devolve
     UTC e, em Brasília (UTC−3), das 21h à meia-noite ele já virou o dia
     seguinte — o campo passaria a recusar a entrega de amanhã achando que é
     ontem.
     ======================================================================= */

  function hojeLocal() {
    var d = new Date();
    var m = String(d.getMonth() + 1);
    var dia = String(d.getDate());
    return d.getFullYear() + '-' + (m.length < 2 ? '0' + m : m) + '-' +
           (dia.length < 2 ? '0' + dia : dia);
  }

  function dataPorExtenso(iso) {
    if (!iso) return '';
    var p = iso.split('-');
    return p[2] + '/' + p[1] + '/' + p[0];
  }

  var campoData = $('[data-data-entrega]');
  if (campoData) campoData.setAttribute('min', hojeLocal());

  /* =======================================================================
     O CONTADOR DO BILHETE
     ======================================================================= */

  var bilhete = $('[data-conta-letras]');
  var letras = $('[data-letras]');
  if (bilhete && letras) {
    bilhete.addEventListener('input', function () {
      letras.textContent = bilhete.value.length;
    });
  }

  /* =======================================================================
     VALIDAÇÃO

     O `novalidate` no <form> é de propósito: a bolha nativa do navegador
     aparece num campo só, some sozinha e não é lida por leitor de tela em
     todos os casos. Aqui o erro é texto na tela, junto do botão, e o foco vai
     para o primeiro campo que falta.
     ======================================================================= */

  var erro = $('[data-checkout-erro]');
  var botao = $('[data-ir-pagar]');

  function mostrarErro(msg, campo) {
    if (erro) { erro.textContent = msg; erro.classList.remove('is-hidden'); }
    if (campo) {
      campo.focus();
      campo.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }
  function limparErro() {
    if (erro) { erro.textContent = ''; erro.classList.add('is-hidden'); }
  }

  var ROTULOS = {
    destinatario: 'o nome de quem recebe',
    data:         'a data da entrega'
  };

  function validar() {
    var faltando = $$('[required]', form).filter(function (c) { return !c.value.trim(); });
    if (faltando.length) {
      var c = faltando[0];
      mostrarErro('Falta ' + (ROTULOS[c.name] || 'um campo obrigatório') + '.', c);
      return false;
    }
    /* Telefone: conta DÍGITOS em vez de casar máscara, porque as pessoas
       escrevem com ponto, traço, espaço e +55 à vontade. Dez é fixo com DDD,
       onze é celular com o nono dígito. O campo é opcional, então só valida
       quem escreveu alguma coisa. */
    var tel = form.elements.tel_destinatario;
    if (tel && tel.value.trim() && tel.value.replace(/\D/g, '').length < 10) {
      mostrarErro('O telefone de quem recebe precisa do DDD e do número completo.', tel);
      return false;
    }
    limparErro();
    return true;
  }

  form.addEventListener('input', limparErro);

  /* =======================================================================
     OS ATRIBUTOS DO PEDIDO

     Chaves em português e por extenso porque é ASSIM que elas aparecem no
     admin da Shopify, na tela do pedido, para quem vai montar a peça. Não é
     nome de variável: é rótulo lido por gente.
     ======================================================================= */

  function atributos() {
    var d = {};
    $$('input, textarea, select', form).forEach(function (c) {
      if (c.type === 'radio') { if (c.checked) d[c.name] = c.value; }
      else { d[c.name] = c.value.trim(); }
    });

    var a = {
      'Quem recebe': d.destinatario,
      'Data da entrega': dataPorExtenso(d.data),
      'Janela de entrega': d.janela || ''
    };
    if (d.tel_destinatario) a['Telefone de quem recebe'] = d.tel_destinatario;
    if (d.ocasiao)          a['Ocasião'] = d.ocasiao;
    if (d.bilhete)          a['Bilhete'] = d.bilhete;
    if (d.assinatura)       a['Bilhete assinado por'] = d.assinatura;
    return a;
  }

  /* =======================================================================
     A IDA PARA O CHECKOUT

     Três chamadas em sequência, e a ordem importa:

     1. `/cart/clear.js` — o carrinho da Shopify pode ter sobra de uma
        tentativa anterior. Sem limpar, o cliente que voltou do checkout para
        corrigir a data sai com o pedido em DOBRO. É o defeito mais provável
        de todo este arquivo, e o mais difícil de reproduzir sem querer.
     2. `/cart/add.js` com todas as linhas de uma vez. Uma chamada por item
        multiplicaria a chance de meio carrinho.
     3. `/cart/update.js` com os atributos — depois do add, porque
        `clear.js` também apaga atributo.

     Só então `location.assign('/checkout')`. Nada de `window.open`: a compra
     continua na mesma aba, que é onde o cliente espera que ela esteja.
     ======================================================================= */

  function pedirJSON(url, corpo) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) {
          var e = new Error((j && (j.description || j.message)) || ('Erro ' + r.status));
          e.corpo = j;
          throw e;
        }
        return j;
      });
    });
  }

  function ocupado(sim) {
    if (!botao) return;
    botao.disabled = sim;
    botao.setAttribute('aria-busy', sim ? 'true' : 'false');
    var r = $('[data-rotulo-pagar]', botao);
    if (r) r.textContent = sim ? 'Levando para o pagamento…' : 'Ir para o pagamento';
  }

  function irPagar() {
    var s = E.ler();
    if (!s.length) { pintarResumo(); return; }
    if (!validar()) return;

    /* AS LINHAS SEM VARIANTE PARAM TUDO, e param ANTES de qualquer chamada.
       Mandar o cliente a um checkout com metade do pedido é pior do que não
       deixar ele ir: ele paga o que chegou lá e descobre a falta depois. */
    var semVariante = s.filter(function (l) { return !E.VARIANTES[l.id]; });
    if (semVariante.length) {
      var nomes = semVariante.map(function (l) {
        var p = achar(l.id); return p ? p.nome : l.id;
      }).join(', ');
      mostrarErro('Não foi possível levar ao pagamento: ' + nomes +
        (semVariante.length > 1 ? ' ainda não estão' : ' ainda não está') +
        ' disponível para compra on-line. Fale com a loja pelo WhatsApp e ela fecha o pedido.');
      return;
    }

    if (!NA_LOJA) {
      mostrarErro('Este é o protótipo local: o pagamento roda na loja publicada, ' +
                  'onde o checkout da Shopify existe. O formulário e a validação ' +
                  'acima são os mesmos.');
      return;
    }

    var itens = s.map(function (l) {
      return { id: E.VARIANTES[l.id], quantity: l.qtd };
    });

    ocupado(true);
    pedirJSON('/cart/clear.js', {})
      .then(function () { return pedirJSON('/cart/add.js', { items: itens }); })
      .then(function () { return pedirJSON('/cart/update.js', { attributes: atributos() }); })
      .then(function () { window.location.assign('/checkout'); })
      .catch(function (err) {
        ocupado(false);
        mostrarErro('Não deu para abrir o pagamento agora (' + err.message +
                    '). Tente de novo, ou fale com a loja pelo WhatsApp.');
      });
  }

  form.addEventListener('submit', function (ev) { ev.preventDefault(); irPagar(); });

  /* =======================================================================
     GANCHOS DE REPINTURA

     O resumo repinta porque a gaveta continua acessível nesta página — dá
     para mudar a quantidade ali e o resumo tem de acompanhar. Como o app.js
     não emite evento nenhum, o gancho é o `storage` (que só dispara em OUTRAS
     abas) mais um clique delegado na gaveta, para a mesma aba. O
     `setTimeout(0)` é necessário porque o listener da gaveta e este disputam
     o mesmo clique, e o do app.js é quem grava — sem o adiamento o resumo
     leria o valor anterior.
     ======================================================================= */

  pintarResumo();
  window.addEventListener('storage', pintarResumo);
  var gaveta = $('[data-carrinho]');
  if (gaveta) gaveta.addEventListener('click', function () { setTimeout(pintarResumo, 0); });
})();
